import { Box, CircularProgress } from "@mui/material";

/**
 * Loading state component for the chat panel.
 * Displays a centered spinner while chat messages or channel data is loading.
 */
export function ChatLoadingState() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
